export default __webpack_public_path__ + "static/isabel@2x-17277984f32c9211d061fec9c6deb0a1.png";